Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var withoutProps = require('without-props').default;

var DeviceUtils = require('@src/utils/device-utils').default;

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj['default'] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var __rest =
  (undefined && undefined.__rest) ||
  function(s, e) {
    var t = {};
    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p1 = Object.getOwnPropertySymbols(s); i < p1.length; i++) {
        if (e.indexOf(p1[i]) < 0) t[p1[i]] = s[p1[i]];
      }
    return t;
  };

var BgMusic = (function(_React$PureComponent) {
  (0, _inherits3['default'])(BgMusic, _React$PureComponent);

  function BgMusic() {
    (0, _classCallCheck3['default'])(this, BgMusic);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (BgMusic.__proto__ || Object.getPrototypeOf(BgMusic)).apply(this, arguments));

    _this.handleClick = function() {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        isPlaying = _this$props.isPlaying,
        onClick = _this$props.onClick;

      onClick?.(!isPlaying);
      onChange(!isPlaying);
    };
    _this.onWeixinJSBridgeReady = function(props) {
      var _ref = props || _this.props,
        isPlaying = _ref.isPlaying;
      if (isPlaying) {
        _this.playAudio();
      } else {
        _this.pauseAudio();
      }
    };
    _this.playAudio = function() {
      // 重新播放时，音频从上传暂停位置继续播放
      // _this.$audioEl.load();
      _this.$audioEl.play();
      var _this$props = _this.props;
      if (_this.$audioEl.paused) {
        _this$props.onChange(false);
      } else {
        _this$props.onChange(true);
      }
    };
    _this.pauseAudio = function() {
      _this.$audioEl.pause();
      var _this$props = _this.props;
      if (!_this.$audioEl.paused) {
        _this$props.onChange(true);
      }
    };
    return _this;
  }

  (0, _createClass3['default'])(
    BgMusic,
    [
      {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          var _props = this.props,
            onChange = _props.onChange,
            isPlaying = _props.isPlaying;

          if (DeviceUtils.isIOS() && BgMusic.isWeixin() && isPlaying) {
            document.addEventListener(
              'WeixinJSBridgeReady',
              function() {
                _this2.playAudio();
              },
              false
            );
          } else {
            this.onWeixinJSBridgeReady();
          }
        }
      },
      {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (nextProps !== this.props && nextProps.isPlaying !== this.props.isPlaying) {
            this.onWeixinJSBridgeReady(nextProps);
          }
        }
      },
      {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          document.removeEventListener('WeixinJSBridgeReady', this.onWeixinJSBridgeReady);
        }
      },
      {
        key: 'render',
        value: function render() {
          var _this3 = this;

          var _a = withoutProps(this.props, ['isPlaying']),
            style = _a.style,
            className = _a.className,
            renderPause = _a.renderPause,
            renderPlay = _a.renderPlay,
            restProps = __rest(_a, ['style', 'className', 'renderPause', 'renderPlay']);
          var isPlaying = this.props.isPlaying;
          return React.createElement(
            'div',
            { className: className, style: style, onClick: this.handleClick },
            React.createElement(
              'audio',
              (0, _extends3['default'])(
                {
                  ref: function ref(el) {
                    return (_this3.$audioEl = el);
                  },
                  loop: true,
                  id: 'bgmAudio'
                },
                restProps
              )
            ),
            isPlaying ? renderPlay() : renderPause()
          );
        }
      }
    ],
    [
      {
        key: 'isWeixin',
        value: function isWeixin() {
          return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1;
        }
      }
    ]
  );
  return BgMusic;
})(React.PureComponent);

exports['default'] = BgMusic;

BgMusic.defaultProps = {};
module.exports = exports['default'];
